import { Client } from 'src/api/Client';

export interface UserMemoryValue {
  created_at: string;
  updated_at: string;
  field_id: string;
  field_name: string;
  field_type: 'text' | 'markdown' | 'list';
  value: string | string[];
  display_name: string;
  item_id: string;
}

export interface UserMemoryCategory {
  category_id: string;
  created_at: string;
  updated_at: string;
  id: string;
  user_id: string;
  category_name: string;
  category_description: string;
  values: UserMemoryValue[];
}

export type UserMemoryResponse = UserMemoryCategory[];

export interface UpdateUserMemoryValue {
  field_name: string;
  memory_value: string | string[];
}

export interface UpdateUserMemoryRequest {
  category_id: string;
  values: UpdateUserMemoryValue[];
}

class MemoryClient extends Client {
  private readonly Route = {
    USER_MEMORY: `${this.http.baseUrl}/ai-agent/user-memory/{brandId}`,
    UPDATE_USER_MEMORY: `${this.http.baseUrl}/ai-agent/user-memory/{brandId}`,
  };

  /**
   * Get user memory data for a specific brand
   * @param brandId - The brand ID to fetch memory for
   * @returns Promise<UserMemoryResponse>
   */
  getUserMemory(brandId: string): Promise<UserMemoryResponse> {
    const url = this.Route.USER_MEMORY.replace('{brandId}', brandId);
    return this.http.get<UserMemoryResponse>(url) as unknown as Promise<UserMemoryResponse>;
  }

  /**
   * Update user memory data for a specific brand
   * @param brandId - The brand ID to update memory for
   * @param data - The update request data
   * @returns Promise<UserMemoryResponse>
   */
  updateUserMemory(brandId: string, data: UpdateUserMemoryRequest): Promise<UserMemoryResponse> {
    const url = this.Route.UPDATE_USER_MEMORY.replace('{brandId}', brandId);
    return this.http.put<UserMemoryResponse>(url, data) as unknown as Promise<UserMemoryResponse>;
  }
}

export { MemoryClient };
